import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from '@shared/components/layout/RootLayout';
import { ProtectedRoute } from '@shared/features/auth/components/ProtectedRoute';

// Public pages
import HomePage from '@shared/pages/public/HomePage';
import LoginPage from '@shared/pages/public/LoginPage';
import RegisterPage from '@shared/pages/public/RegisterPage';
import ForgotPasswordPage from '@shared/pages/public/ForgotPasswordPage';
import ResetPasswordPage from '@shared/pages/public/ResetPasswordPage';
import ContactPage from '@shared/pages/public/ContactPage';
import PrivacyPage from '@shared/pages/public/PrivacyPage';

// Protected pages
import RecentCasesPage from '@shared/pages/protected/RecentCasesPage';
import SearchPage from '@shared/pages/protected/SearchPage';
import CaseDetailPage from '@shared/pages/protected/CaseDetailPage';
import SettingsPage from '@shared/pages/protected/SettingsPage';

// Error pages
import NotFoundPage from '@shared/pages/NotFoundPage';
import ErrorPage from '@shared/pages/ErrorPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      // Public routes
      { 
        index: true, 
        element: <HomePage /> 
      },
      { 
        path: 'login', 
        element: <LoginPage /> 
      },
      { 
        path: 'register', 
        element: <RegisterPage /> 
      },
      {
        path: 'forgot-password',
        element: <ForgotPasswordPage />
      },
      {
        path: 'reset-password',
        element: <ResetPasswordPage />
      },
      {
        path: 'contact',
        element: <ContactPage />
      },
      {
        path: 'privacy',
        element: <PrivacyPage />
      },

      // Protected routes
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: 'recent',
            element: <RecentCasesPage />
          },
          {
            path: 'search',
            element: <SearchPage />
          },
          {
            path: 'case/:id',
            element: <CaseDetailPage />
          },
          {
            path: 'settings',
            element: <SettingsPage />
          },
        ]
      },
      
      // 404 page
      { 
        path: '*', 
        element: <NotFoundPage /> 
      },
    ]
  }
]);